import { Component } from '@angular/core';
import { TopLevelCommunityItemComponent as BaseComponent } from '../../../../../../app/home-page/top-level-community-list/top-level-community-item/top-level-community-item.component';

/**
 * OPARA: Diese Komponente stellt sicher, dass TopLevelCommunityItemComponent im Custom-Theme verfügbar ist
 */
@Component({
  selector: 'ds-top-level-community-item',
  styleUrls: ['../../../../../../app/home-page/top-level-community-list/top-level-community-item/top-level-community-item.component.scss'],
  templateUrl: '../../../../../../app/home-page/top-level-community-list/top-level-community-item/top-level-community-item.component.html'
})
export class TopLevelCommunityItemComponent extends BaseComponent {}
